module.exports = __webpack_public_path__ + "static/img/banner-04.3b650bfc.png";